import { useEffect } from "react";

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    if (!title) return;
    document.title = title;
  }, [title]);
};
